angular.module('common.directives.recompile', [])

    // Magic directive for runtime templates recompilation. Use with care!
    //
    // Example:
    //
    // In template:
    // <div recompile='someBoolVarOnScope'>
    //    //{{something to recompile}}...
    // </div>
    //
    // In controller:
    // $scope.someBoolVarOnScope = true; for recompilation.
    .directive('recompile', function ($compile, $parse) {
        return {
            restrict: 'A',
            scope: true, // required to be able to clear watchers safely
            compile: function (el) {
                var template = angular.element('<a></a>').append(el.clone()).html(); // source template as string, with some changes
                // <a></a> is important thing. Don't know why, but it doesn't work without it...

                return function link(scope, $el, attrs) {
                    var stopWatching = scope.$parent.$watch(attrs.recompile, function (newVal) {
                        if (!newVal || newVal === 'false') {
                            return;
                        }

                        $parse(attrs.recompile).assign(scope.$parent, false);

                        // recompile
                        var newEl = $compile(template)(scope.$parent);
                        $el.replaceWith(newEl);

                        // Destroy old scope, reassign new scope.
                        stopWatching();
                        scope.$destroy();
                    });
                };
            }
        };
    })

;
